import { compose, prop } from 'ramda';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getDocumentIds = compose(prop('documentIds'), getRoot);
export const getFiles = compose(prop('files'), getRoot);
export const getUploadErrors = compose(prop('uploadErrors'), getRoot);
